import { DOG_AGE_STAGE_OPTIONS } from 'root-constants'
import moreThanFiveYears from '../../assets/images/sprite/moreThanFiveYears.svg'
import oneTwoYears from '../../assets/images/sprite/oneTwoYears.svg'
import sevenTwelveMonths from '../../assets/images/sprite/sevenTwelveMonths.svg'
import twoFiveYears from '../../assets/images/sprite/twoFiveYears.svg'
import zeroSixMonths from '../../assets/images/sprite/zeroSixMonths.svg'
import { TOption } from './types'

export const DO_NOT_KNOW_ANSWER = `I don’t know`
export const NOTHING_ANSWER = 'Nothing'

export const AGE_OPTIONS: Array<TOption> = [
  {
    value: DOG_AGE_STAGE_OPTIONS.YOUNGER_THEN_SIX_MONTH,
    image: zeroSixMonths,
    translationKey: 'onboarding.age.youngerThenSixMonth',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.SIX_TWELVE_MONTHS,
    image: sevenTwelveMonths,
    translationKey: 'onboarding.age.sixTwelveMonth',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.ONE_TWO_YEAR,
    image: oneTwoYears,
    translationKey: 'onboarding.age.oneTwoYear',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.TWO_SEVEN_YEARS,
    image: twoFiveYears,
    translationKey: 'onboarding.age.twoSevenYears',
  },
  {
    value: DOG_AGE_STAGE_OPTIONS.MORE_THAN_SEVEN_YEARS,
    image: moreThanFiveYears,
    translationKey: 'onboarding.age.moreThanSevenYears',
  },
]

export const enum DogsBreed {
  MIXED_BREED = 'Mixed Breed',
  GOLDEN_RETRIEVER = 'Golden Retriever',
  LABRADOR_RETRIEVER = 'Labrador Retriever',
  DACHSHUND = 'Dachshund',
  GERMAN_SHEPHERD = 'German Shepherd',
  FRENCH_BULLDOG = 'French Bulldog',
  AMERICAN_PIT_BULL_TERRIER = 'American Pit Bull Terrier',
  CHIHUAHUA = 'Chihuahua',
  BORDER_COLLIE = 'Border Collie',
  BEAGLE = 'Beagle',
  SIBERIAN_HUSKY = 'Siberian Husky',
  YORKSHIRE_TERRIER = 'Yorkshire Terrier',
  SHIH_TZU = 'Shih Tzu',
  POODLE = 'Poodle',
  GOLDENDOODLE = 'Goldendoodle',
  AU_SHEPHERD = 'Australian Shepherd',
  COCKAPOO = 'Cockapoo',
  CAVAPOO = 'Cavapoo',
  MALTIPOO = 'Maltipoo',
  TERRIER = 'Jack Russell Terrier',
  POMERANIAN = 'Pomeranian',
}
